interface DadosPessoaisProps {
  color?: string;
  width?: string;
  height?: string;
}

export const DadosPessoais = ({
  width = '23',
  height = '26',
  color = '#942000',
}: DadosPessoaisProps) => {
  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.25 0.5H12.75C13.4141 0.5 14 1.08594 14 1.75V4.25C14 4.95312 13.4141 5.5 12.75 5.5H10.25C9.54688 5.5 9 4.95312 9 4.25V1.75C9 1.08594 9.54688 0.5 10.25 0.5ZM7.75 3V4.875H2.75C2.39844 4.875 2.125 5.1875 2.125 5.5V18C2.125 18.3516 2.39844 18.625 2.75 18.625H20.25C20.5625 18.625 20.875 18.3516 20.875 18V5.5C20.875 5.1875 20.5625 4.875 20.25 4.875H15.25V3H20.25C21.6172 3 22.75 4.13281 22.75 5.5V18C22.75 19.4062 21.6172 20.5 20.25 20.5H2.75C1.34375 20.5 0.25 19.4062 0.25 18V5.5C0.25 4.13281 1.34375 3 2.75 3H7.75ZM11.5 12.375C10.6016 12.375 9.78125 11.9062 9.3125 11.125C8.88281 10.3828 8.88281 9.40625 9.3125 8.625C9.78125 7.88281 10.6016 7.375 11.5 7.375C12.3594 7.375 13.1797 7.88281 13.6484 8.625C14.0781 9.40625 14.0781 10.3828 13.6484 11.125C13.1797 11.9062 12.3594 12.375 11.5 12.375ZM10.25 13.625H12.75C14.4688 13.625 15.875 15.0312 15.875 16.75C15.875 17.1016 15.5625 17.375 15.25 17.375H7.75C7.39844 17.375 7.125 17.1016 7.125 16.75C7.125 15.0312 8.49219 13.625 10.25 13.625Z'
        fill={`${color}`}
      />
    </svg>
  );
};
